// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA44uIivHJWfTWPFuxbMms5BG1hOPGkdqQ",
  authDomain: "wordhit-30d64.firebaseapp.com",
  projectId: "wordhit-30d64",
  storageBucket: "wordhit-30d64.firebasestorage.app",
  messagingSenderId: "478084312195",
  appId: "1:478084312195:web:35969c8c67ed07fb7bffb6",
  measurementId: "G-HQ8K7MSZNN"
};

// Initialize Firebase
let app;
let analytics;

try {
  app = initializeApp(firebaseConfig);
  
  // Only initialize analytics in browser environment
  if (typeof window !== "undefined") {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.error("Firebase initialization error:", error);
}

export { app, analytics };

/** GCM/FCM Sender ID (Firebase project number) - used for Android push Installation registration */
export const FCM_SENDER_ID = firebaseConfig.messagingSenderId;

